import { Box } from "@mui/material";

const ReportPagePaper = ({
  pdfLoading,
  backgroundColor = "#fff",
  children
}) => (
  <Box
    style={{
      height: "11in",
      width: "8.5in",
      overflow: "hidden",
      backgroundColor
    }}
    display="flex"
    flexDirection="column"
    mb={pdfLoading ? 0 : 1}
  >
    {children}
  </Box>
);
export default ReportPagePaper;
